import { blue, cyan, neutral, orange, purple, red } from "@faro-lotv/flat-ui";
import { ImageAnalysisFindingType } from "@faro-lotv/service-wires";

/** Colors that stay distinguishable from each other and from the panorama behind them. */
const CATEGORY_COLORS: Record<ImageAnalysisFindingType, string> = {
  [ImageAnalysisFindingType.safetyObservation]: red[300],
  [ImageAnalysisFindingType.facilityCondition]: orange[400],
  [ImageAnalysisFindingType.constructionElement]: blue[400],
  [ImageAnalysisFindingType.constructionStage]: purple[400],
  [ImageAnalysisFindingType.searchableElement]: cyan[300],
};

/** Used for the findings of a category the backend added after this map was written. */
const UNKNOWN_CATEGORY_COLOR = neutral[300];

/**
 * @param type The category of a finding.
 * @returns the color to draw the finding with.
 */
export function aiFindingColor(type: string | undefined): string {
  return isFindingCategory(type)
    ? CATEGORY_COLORS[type]
    : UNKNOWN_CATEGORY_COLOR;
}

/**
 * @param type The category of a finding.
 * @returns true if the category is one this app knows how to color.
 */
function isFindingCategory(
  type: string | undefined,
): type is ImageAnalysisFindingType {
  // Own keys only, otherwise inherited names like "toString" would match.
  return !!type && Object.hasOwn(CATEGORY_COLORS, type);
}
